// extracted by mini-css-extract-plugin
module.exports = {"chart":"m_z"};